import Axhelper from '@/lib/Axhelper'

class WojewodztwoService {
	constructor() {
		this.baseUrl = window.RUNTIME_CONFIG.API_URL
		this.endpoints = {
			wojewodztwoAll: '/api/wojewodztwo/filters',
			wojewodztwoDetails: '/api/wojewodztwo/details',
			wojewodztwoSearch: '/api/wojewodztwo/filters',
			wojewodztwoCreate: '/api/wojewodztwo',
			wojewodztwoUpdate: '/api/wojewodztwo',
			wojewodztwoDelete: '/api/wojewodztwo',
		}
	}

	async getAll(options = {}) {
		try {
			const {
				limit = 50,
				sortColumn = '_id',
				sortDirection = 'desc',
			} = options

			const params = new URLSearchParams({
				sortcol: sortColumn,
				sortdir: sortDirection,
				limit: String(limit),
			})
			const url = `${this.endpoints.wojewodztwoAll}?${params.toString()}`
			const response = await Axhelper.sendGetAsync(url)

			if (response.error) {
				return {
					data: [],
					error: response.error,
					totalCount: 0,
					hasMore: false,
				}
			}

			const totalCount = response.headers?.['x-total-count']
				? parseInt(response.headers['x-total-count'], 10)
				: response.data?.length || 0

			return {
				data: response.data || [],
				error: null,
				totalCount,
				hasMore: (response.data?.length || 0) < totalCount,
				headers: response.headers,
			}
		} catch (error) {
			console.error('WojewodztwoService.getAll error:', error)
			return {
				data: [],
				error: error.message || 'Failed to fetch wojewodztwa',
				totalCount: 0,
				hasMore: false,
			}
		}
	}

	async getById(wojewodztwoId) {
		try {
			if (!wojewodztwoId) {
				return {
					data: null,
					error: 'Invalid wojewodztwo ID provided',
				}
			}

			const url = `${this.endpoints.wojewodztwoDetails}/${encodeURIComponent(wojewodztwoId)}`
			const response = await Axhelper.sendGetAsync(url)

			if (response.error) {
				return {
					data: null,
					error: response.error,
				}
			}

			return {
				data: response.data || null,
				error: null,
			}
		} catch (error) {
			console.error('WojewodztwoService.getById error:', error)
			return {
				data: null,
				error: error.message || 'Failed to fetch wojewodztwo details',
			}
		}
	}

	async search(searchTerm, options = {}) {
		try {
			if (!searchTerm) {
				return {
					data: [],
					error: 'Invalid search term provided',
					totalCount: 0,
					hasMore: false,
				}
			}

			const {
				limit = 50,
				sortColumn = '_id',
				sortDirection = 'desc',
			} = options

			const params = new URLSearchParams({
				sortcol: sortColumn,
				sortdir: sortDirection,
				limit: String(limit),
			})
			const url = `${this.endpoints.wojewodztwoSearch}?searchText=${encodeURIComponent(searchTerm)}&${params.toString()}`
			const response = await Axhelper.sendGetAsync(url)

			if (response.error) {
				return {
					data: [],
					error: response.error,
					totalCount: 0,
					hasMore: false,
				}
			}

			const totalCount = response.headers?.['x-total-count']
				? parseInt(response.headers['x-total-count'], 10)
				: response.data?.length || 0

			return {
				data: response.data || [],
				error: null,
				totalCount,
				hasMore: (response.data?.length || 0) < totalCount,
				headers: response.headers,
			}
		} catch (error) {
			console.error('WojewodztwoService.search error:', error)
			return {
				data: [],
				error: error.message || 'Failed to search wojewodztwa',
				totalCount: 0,
				hasMore: false,
			}
		}
	}

	async create(wojewodztwoData) {
		try {
			const response = await Axhelper.sendPostAsync(this.endpoints.wojewodztwoCreate, wojewodztwoData)

			if (response.error) {
				return {
					success: false,
					error: response.error,
				}
			}

			return {
				success: true,
				error: null,
				data: response.data || null,
			}
		} catch (error) {
			console.error('WojewodztwoService.create error:', error)
			return {
				success: false,
				error: error.message || 'Failed to create wojewodztwo',
			}
		}
	}

	async update(wojewodztwoId, wojewodztwoData) {
		try {
			if (!wojewodztwoId) {
				return {
					success: false,
					error: 'Invalid wojewodztwo ID provided',
				}
			}

			const url = `${this.endpoints.wojewodztwoUpdate}/${encodeURIComponent(wojewodztwoId)}`
			const response = await Axhelper.sendPutAsync(url, wojewodztwoData)

			if (response.error) {
				return {
					success: false,
					error: response.error,
				}
			}

			return {
				success: true,
				error: null,
				data: response.data || null,
			}
		} catch (error) {
			console.error('WojewodztwoService.update error:', error)
			return {
				success: false,
				error: error.message || 'Failed to update wojewodztwo',
			}
		}
	}

	async delete(wojewodztwoId) {
		try {
			if (!wojewodztwoId) {
				return {
					success: false,
					error: 'Invalid wojewodztwo ID provided',
					message: null,
				}
			}

			const url = `${this.endpoints.wojewodztwoDelete}/${encodeURIComponent(wojewodztwoId)}`
			const response = await Axhelper.sendDeleteAsync(url)

			if (response.error) {
				return {
					success: false,
					error: response.error,
					message: null,
				}
			}

			return {
				success: true,
				error: null,
				message: response.data || 'Wojewodztwo deleted successfully',
			}
		} catch (error) {
			console.error('WojewodztwoService.delete error:', error)
			return {
				success: false,
				error: error.message || 'Failed to delete wojewodztwo',
				message: null,
			}
		}
	}
}

export default new WojewodztwoService()
